import { PremiumBackground } from '../effects/PremiumBackground';
import React, { useState } from 'react';
import { 
  FileText, 
  X, 
  CheckCircle2, 
  ArrowRight,
  BookOpen
} from 'lucide-react';

export interface KnowledgeVaultProps {
  id?: string;
}

interface MemoItem {
  id: string;
  category: string;
  title: string;
  readTime: string;
  leadParagraph: string;
  fullContent?: string;
}

const ARTICLES: MemoItem[] = [
  {
    id: 'memo-1', category: 'ОЦЕНКА МЕДЦЕНТРА', title: 'Оценка стоимости стоматологии: калькулятор EBITDA для клиник на 3 кресла.', readTime: '5 мин.',
    leadParagraph: 'Оценка стоматологии на 3 кресла часто проводится кустарными методами. Узнайте, как институциональные фонды применяют нормализацию прибыли (QoE) и оценивают клиники до 7.5x EBITDA.'
  },
  {
    id: 'memo-2', category: 'M&A СТРАТЕГИЯ', title: 'Как дорого и быстро продать медицинскую клинику в Москве.', readTime: '7 мин.',
    leadParagraph: 'Разбор 5 критических ошибок при продаже клиники: почему объявления на открытых площадках обрушивают цену актива и почему закрытые синдикаты платят премию за конфиденциальность.'
  },
  {
    id: 'memo-3', category: 'НАЛОГИ & 54.1 НК РФ', title: 'Дробление бизнеса и 54.1 НК РФ: обеление медицинской клиники перед продажей.', readTime: '8 мин.',
    leadParagraph: 'Скрытые налоговые риски (ст. 54.1 НК РФ) — главная причина срыва M&A сделок. Инструкция по безналоговой консолидации и подготовке к Due Diligence.'
  },
  {
    id: 'memo-4', category: 'EXIT СТРАТЕГИЯ', title: 'Льгота 284.2 НК РФ: Как продать ООО с медицинской лицензией с налогом 0%.', readTime: '6 мин.',
    leadParagraph: 'Условия применения статьи 284.2 НК РФ для владельцев клиник. Требования к непрерывному владению долями более 5 лет и ограничения при продаже активов.'
  },
  {
    id: 'memo-5', category: 'ПОИСК ИНВЕСТОРОВ', title: 'Федеральные сети и инвестфонды: кому продать многопрофильный медицинский центр.', readTime: '5 мин.',
    leadParagraph: 'Обзор основных стратегов на рынке медицины РФ. Требования фондов Private Equity и федеральных сетей к управленческой отчетности и структуре выручки.'
  },
  {
    id: 'memo-6', category: 'DUE DILIGENCE', title: 'Финансовый аудит и Quality of Earnings (QoE) в частной медицине.', readTime: '9 мин.',
    leadParagraph: 'Как защитить оценку бизнеса при Due Diligence. Исключение личных расходов собственника (Add-backs) из себестоимости и нормализация арендных ставок.'
  },
  { id: 'memo-7', category: 'РЫНОК M&A', title: 'Слияния и поглощения (M&A) медицинских клиник в России: тренды 2026', readTime: '4 мин.', leadParagraph: 'Консолидация рынка: почему одиночные клиники теряют рентабельность, и как стратеги объединяют активы в филиальные сети.' },
  { id: 'memo-8', category: 'ОЦЕНКА БИЗНЕСА', title: 'Мультипликаторы EBITDA для косметологических клиник и хирургических стационаров', readTime: '5 мин.', leadParagraph: 'Сравнение инвестиционной привлекательности различных медицинских ниш. Разрыв мультипликаторов между стоматологиями и пластической хирургией.' },
  { id: 'memo-9', category: 'БЕЗОПАСНОСТЬ', title: 'Защита коммерческой тайны (NDA) и защита от рейдерского захвата клиники', readTime: '6 мин.', leadParagraph: 'Почему нельзя допускать утечки информации о продаже. Риск увода команды врачей конкурентами и алгоритм подписания Mutual NDA.' },
  { id: 'memo-10', category: 'УПРАВЛЕНИЕ', title: 'Как выйти из операционки и передать клинику в управление перед M&A', readTime: '7 мин.', leadParagraph: 'Автономная операционная система Clinic OS: как доказать покупателю, что клиника будет работать и приносить прибыль без участия основателя.' },
  // Adding 20 more dummy items representing the 30 blocks
  { id: 'memo-11', category: 'HR & КОМАНДА', title: 'Как удержать врачей-звезд при продаже клиники: Phantom Equity и Retention Bonus', readTime: '5 мин.', leadParagraph: 'Опционные программы и "золотые наручники" для ключевого медицинского персонала на переходный период M&A сделки.' },
  { id: 'memo-12', category: 'ФИНАНСЫ', title: 'Оценка нематериальных активов: база пациентов, бренд и медицинская лицензия', readTime: '4 мин.', leadParagraph: 'Как оцифровать и продать лояльность пациентов. Расчет LTV (Lifetime Value) в стоматологии и многопрофильных центрах.' },
  { id: 'memo-13', category: 'СТРУКТУРИРОВАНИЕ', title: 'Term Sheet и договор купли-продажи (SPA) в медицинском M&A', readTime: '6 мин.', leadParagraph: 'Основные положения Term Sheet: exclusivity, escrow, indemnities. Как защитить базовую цену клиники на этапе обязывающей документации.' },
  { id: 'memo-14', category: 'РИСКИ 238 УК РФ', title: 'Санация медицинского оборудования: защита от ст. 238.1 УК РФ', readTime: '8 мин.', leadParagraph: 'Аудит регистрационных удостоверений (РУ) Росздравнадзора. Легализация медицинских аппаратов до старта Due Diligence.' },
  { id: 'memo-15', category: 'ОТЧЕТНОСТЬ', title: 'Управленческий учет в медицине: как показать реальную прибыль инвестору', readTime: '5 мин.', leadParagraph: 'Переход от кассового метода к методу начисления. Учет авансов пациентов (Cost-to-Complete) за ортодонтическое лечение.' },
  { id: 'memo-16', category: 'ПРОБЛЕМНЫЕ АКТИВЫ', title: 'Как продать клинику с долгами или кассовыми разрывами', readTime: '6 мин.', leadParagraph: 'Дистресс M&A: санация баланса, реструктуризация кредиторской задолженности и переговоры с банками-кредиторами.' },
  { id: 'memo-17', category: 'МАРКЕТИНГ', title: 'Маркетинговый форензик: аудит каналов привлечения пациентов', readTime: '4 мин.', leadParagraph: 'Анализ CAC (Cost of Customer Acquisition) и ROMI. Проверка накруток отзывов на ПроДокторов и Яндекс.Картах перед сделкой.' },
  { id: 'memo-18', category: 'НЕДВИЖИМОСТЬ', title: 'Продажа клиники с помещением vs арендный бизнес', readTime: '5 мин.', leadParagraph: 'Разделение операционного бизнеса (OpCo) и недвижимости (PropCo) для максимизации итоговой суммы M&A сделки.' },
  { id: 'memo-19', category: 'ДЕТСКИЕ КЛИНИКИ', title: 'Специфика продажи и оценки детских медицинских центров', readTime: '4 мин.', leadParagraph: 'Фактор сезонности, оценка базы постоянных пациентов и требования инвесторов к педиатрическим активам.' },
  { id: 'memo-20', category: 'ИНВЕСТИЦИИ', title: 'Привлечение Smart Money: как найти партнера для масштабирования клиники', readTime: '5 мин.', leadParagraph: 'Отличие финансовых инвесторов от стратегических. Венчурные инвестиции (VC) в цифровое здравоохранение (HealthTech).' },
  { id: 'memo-21', category: 'УПРАВЛЕНИЕ КАПИТАЛОМ', title: 'Family Offices и частные фонды как покупатели медицинских активов', readTime: '6 мин.', leadParagraph: 'Почему семейные офисы (Family Offices) предпочитают медицину как защитный актив. Особенности переговоров с HNW-инвесторами.' },
  { id: 'memo-22', category: 'БЫСТРЫЙ ВЫХОД', title: 'Экспресс-сделка: как продать клинику за 3 месяца', readTime: '4 мин.', leadParagraph: 'Дорожная карта ускоренного M&A: подготовка Data Room, параллельные переговоры с синдикатом и фаст-трек аудит.' },
  { id: 'memo-23', category: 'КЛИЕНТСКАЯ БАЗА', title: 'Передача базы пациентов: юридические аспекты 152-ФЗ', readTime: '5 мин.', leadParagraph: 'Защита персональных данных при M&A сделке. Как передать МИС (Медицинскую информационную систему) покупателю без штрафов Роскомнадзора.' },
  { id: 'memo-24', category: 'ЭСТЕТИКА', title: 'Специфика продажи клиник эстетической медицины и косметологии', readTime: '4 мин.', leadParagraph: 'Оценка запасов филлеров и ботулотоксинов. Риски "серых" препаратов и влияние на мультипликатор оценки EBITDA.' },
  { id: 'memo-25', category: 'ЭКОНОМИКА', title: 'Себестоимость кресло-часа (ABC-Costing) в стоматологии', readTime: '5 мин.', leadParagraph: 'Юнит-экономика клиники глазами финансового аналитика покупателя. Как оптимизация загрузки кресел увеличивает капитализацию бизнеса.' },
  { id: 'memo-26', category: 'ОБОРУДОВАНИЕ', title: 'Продажа рентген-кабинетов и диагностических центров', readTime: '5 мин.', leadParagraph: 'Сложности оценки тяжелого оборудования (КТ, МРТ). Амортизация, стоимость ремонта и лицензионные требования.' },
  { id: 'memo-27', category: 'ФРАНШИЗА', title: 'Продажа клиники в составе франшизной сети', readTime: '4 мин.', leadParagraph: 'Ограничения договоров коммерческой концессии. Как согласовать смену собственника (Change of Control) с управляющей компанией.' },
  { id: 'memo-28', category: 'КОНСАЛТИНГ', title: 'Брокер по продаже клиник vs Институциональный M&A-бутик', readTime: '6 мин.', leadParagraph: 'Почему кустарные брокеры "сжигают" актив на Avito, и как бутики создают аукцион среди институциональных покупателей.' },
  { id: 'memo-29', category: 'АУДИТ', title: 'Скрытые дефекты: почему инвесторы снижают цену клиники на 40%', readTime: '5 мин.', leadParagraph: 'Главные Red Flags в Due Diligence: "мертвые души" в штате, пересортица на складе, неучтенные скидки пациентам.' },
  { id: 'memo-30', category: 'СДЕЛКИ', title: 'Эскроу-счета и отложенные платежи (Earn-out) при продаже клиники', readTime: '6 мин.', leadParagraph: 'Структурирование расчетов. Как основателю гарантированно получить вторую часть суммы после передачи бизнеса новому владельцу.' }
];

export const KnowledgeVault: React.FC<KnowledgeVaultProps> = ({ id = 'vault-docs' }) => {
  const [selectedMemo, setSelectedMemo] = useState<MemoItem | null>(null);
  const [emailInput, setEmailInput] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showAll, setShowAll] = useState(false);

  const visibleArticles = showAll ? ARTICLES : ARTICLES.slice(0, 6);

  const handleOpenMemo = (memo: MemoItem) => {
    setSelectedMemo(memo);
    setIsSubmitted(false);
    setEmailInput('');
  };

  const handleDiscuss = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!emailInput) return;
    setIsLoading(true);
    try {
      await fetch('/api/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type: 'case_discussion', memo: selectedMemo?.title, contact: emailInput })
      }).catch(() => null);
      setIsSubmitted(true);
    } catch {
      setIsSubmitted(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section
      id={id}
      aria-label="The Knowledge Vault: Архитектура M&A сделок"
      className="relative w-full bg-[#FAF8F5] text-[#141416] py-24 md:py-32 border-t border-[#EAE5DE] font-sans overflow-hidden"
    >
      <PremiumBackground variant={4} />

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
        
        <div className="max-w-4xl mb-16 flex flex-col gap-6">
          <div className="luxury-eyebrow text-[#8C6D37] flex items-center gap-2.5 font-bold tracking-[0.2em] uppercase">
            <span className="w-1.5 h-1.5 rounded-none bg-[#8C6D37]" />
            ЭТАЖ 14 // БАЗА ЗНАНИЙ M&A // ОТКРЫТЫЙ ДОСТУП
          </div>

          <h2 className="text-3xl sm:text-5xl lg:text-[54px] font-serif font-semibold text-[#141416] tracking-[-0.02em] leading-[1.08]">
            Интеллектуальный капитал: <br />
            <span className="text-[#64748B] italic font-serif">практика оценки и продажи клиник</span>
          </h2>

          <div className="text-[16px] sm:text-[17px] text-[#334155] leading-[1.7] font-sans font-normal space-y-3 max-w-3xl pl-5 border-l-[4px] border-[#8C6D37] bg-[#F7F4EE]/60 py-3 rounded-r-[2px] border-y border-r border-[#EAE5DE]">
            <p>
              Ознакомьтесь с 30 ключевыми материалами по предпродажной подготовке (Deep Capitalization), аудиту и защите оценки медицинского бизнеса (до 7.5x EBITDA).
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 relative">
          {visibleArticles.map((memo) => (
            <article
              key={memo.id}
              onClick={() => handleOpenMemo(memo)}
              className="relative group rounded-[2px] p-6 flex flex-col justify-between transition-all duration-300 border border-[#EAE5DE] hover:border-[#8C6D37]/50 bg-white shadow-xs cursor-pointer overflow-hidden"
            >
              <div className="relative z-10">
                <div className="pb-3 mb-4 border-b border-[#EAE5DE] flex items-center justify-between gap-2 font-mono text-[10px]">
                  <span className="text-[#64748B] font-bold tracking-[0.15em] uppercase group-hover:text-[#8C6D37] transition-colors">
                    {memo.category}
                  </span>
                  <span className="text-[#8C6D37] bg-[#F7F4EE] px-2 py-0.5 rounded-[2px] font-bold border border-[#EAE5DE]">
                    {memo.readTime}
                  </span>
                </div>
                <h3 className="text-[16px] sm:text-[18px] font-serif font-semibold text-[#141416] leading-[1.35] mb-3 group-hover:text-[#8C6D37] transition-colors">
                  {memo.title}
                </h3>
              </div>
              <div className="relative z-10 pt-4 flex items-center justify-between text-[#64748B] group-hover:text-[#8C6D37] font-mono text-[10px] font-bold tracking-widest uppercase transition-colors">
                <span>ЧИТАТЬ СТАТЬЮ</span>
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </div>
            </article>
          ))}
        </div>

        {!showAll && ARTICLES.length > 6 && (
          <div className="mt-12 flex justify-center">
            <button
              onClick={() => setShowAll(true)}
              className="group flex items-center gap-3 px-8 py-4 bg-white border border-[#8C6D37]/40 hover:border-[#8C6D37] rounded-[2px] text-[#141416] font-mono text-[11px] font-bold tracking-[0.15em] uppercase transition-all hover:bg-[#FAF8F5] hover:shadow-md"
            >
              <span>ПОКАЗАТЬ ВСЕ {ARTICLES.length} КЕЙСОВ</span>
              <ArrowRight className="w-4 h-4 text-[#8C6D37] transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        )}

      </div>

      {selectedMemo && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-black/50 backdrop-blur-xs animate-in fade-in duration-200">
          <div className="relative w-full max-w-2xl bg-white rounded-[2px] border border-[#EAE5DE] shadow-xl overflow-hidden max-h-[90vh] flex flex-col">
            
            <div className="flex items-center justify-between p-6 border-b border-[#EAE5DE] bg-[#FAF8F5]">
              <div className="space-y-1">
                <span className="font-mono text-[10px] text-[#8C6D37] font-bold uppercase tracking-widest block">
                  {selectedMemo.category}
                </span>
              </div>
              <button
                type="button"
                onClick={() => setSelectedMemo(null)}
                className="w-8 h-8 rounded-[2px] border border-[#EAE5DE] bg-white flex items-center justify-center text-[#64748B] hover:text-[#141416] hover:bg-[#F7F4EE] transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            <div className="p-6 sm:p-8 overflow-y-auto space-y-6 flex-1 bg-white">
              <h3 className="text-2xl sm:text-3xl font-serif font-semibold text-[#141416] leading-[1.25]">
                {selectedMemo.title}
              </h3>

              <div className="text-[15px] sm:text-[16px] text-[#334155] leading-[1.7] font-normal bg-[#FAF8F5] p-6 rounded-[2px] border-l-[4px] border-[#8C6D37] border-y border-r border-[#EAE5DE]">
                <p>{selectedMemo.leadParagraph}</p>
                <p className="mt-4">
                  Для детального разбора механики и получения точных расчетов по данному направлению, мы проводим конфиденциальные консультации в рамках подготовки активов к M&A.
                </p>
              </div>

              <div className="mt-8 pt-8 border-t border-[#EAE5DE]">
                <div className="bg-white border border-[#EAE5DE] rounded-[2px] p-8 shadow-md text-center relative">
                  {!isSubmitted ? (
                    <>
                      <div className="w-12 h-12 rounded-[2px] bg-[#F7F4EE] border border-[#8C6D37]/30 flex items-center justify-center text-[#8C6D37] mx-auto mb-4">
                        <BookOpen className="w-5 h-5" />
                      </div>
                      <div className="font-mono text-[11px] font-bold text-[#8C6D37] uppercase tracking-widest mb-3">
                        [ ОБСУДИТЬ ВАШ КЕЙС С ПАРТНЕРАМИ ]
                      </div>
                      <p className="text-[13px] text-[#334155] leading-relaxed mb-6">
                        Хотите узнать, как применить эти методики для оценки и продажи вашей клиники? Оставьте контакт (Telegram или телефон), и наш M&A-архитектор свяжется с вами.
                      </p>
                      <form onSubmit={handleDiscuss} className="space-y-4">
                        <input
                          type="text"
                          required
                          placeholder="Ваш Telegram или Телефон"
                          value={emailInput}
                          onChange={(e) => setEmailInput(e.target.value)}
                          className="w-full bg-[#FAF8F5] border border-[#EAE5DE] rounded-[2px] px-4 py-3 text-[13px] text-[#141416] focus:outline-none focus:border-[#8C6D37] focus:ring-1 focus:ring-[#8C6D37] font-mono transition-all"
                        />
                        <button
                          type="submit"
                          disabled={isLoading}
                          className="w-full bg-[#141416] hover:bg-[#8C6D37] text-white font-mono text-xs font-bold uppercase py-3.5 px-4 rounded-[2px] transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
                        >
                          <span>{isLoading ? 'ОТПРАВКА...' : 'ОТПРАВИТЬ ЗАЯВКУ'}</span>
                          <ArrowRight className="w-3.5 h-3.5" />
                        </button>
                      </form>
                    </>
                  ) : (
                    <div className="py-4 space-y-3">
                      <CheckCircle2 className="w-10 h-10 text-[#8C6D37] mx-auto" />
                      <h4 className="font-serif font-semibold text-base text-[#141416]">Заявка принята</h4>
                      <p className="text-xs text-[#64748B]">Мы свяжемся с вами в ближайшее время по указанным контактам для обсуждения вашего медицинского актива.</p>
                      <button onClick={() => setSelectedMemo(null)} className="mt-4 text-xs font-mono text-[#8C6D37] hover:underline font-bold">[ Закрыть ]</button>
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>
      )}
    </section>
  );
};
